import { NgModule, ModuleWithProviders, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { LocaleModel } from './shared/models/locale.model';

export const defaultLocale: LocaleModel = {
  title: 'English', lang: 'en', id: 'en-US'
};

export const locales: LocaleModel[] = [
  defaultLocale,
  { title: 'Español', lang: 'es', id: 'es-ES' },
  { title: '中文(简体)', lang: 'zh', id: 'zh-CN' },
  { title: 'Français', lang: 'fr', id: 'fr-FR' },
  { title: 'Deutsch', lang: 'de', id: 'de-DE' },
  { title: 'Italiano', lang: 'it', id: 'it-IT' },
  { title: '日本語', lang: 'ja', id: 'ja' },
  { title: 'Português', lang: 'pt', id: 'pt-PT' }
];

export function getLocaleId(): string {
  const storedLocaleId = localStorage.getItem('locale');
  const targetLocale = locales.find((locale) => locale.id === storedLocaleId) || defaultLocale;
  return targetLocale.id;
}

import localeEs from '@angular/common/locales/es';
import localeZh from '@angular/common/locales/zh';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localePt from '@angular/common/locales/pt';

const importedLocales = [
  localeEs,
  localeZh,
  localeFr,
  localeDe,
  localeIt,
  localeJa,
  localePt
];

// locale registration
importedLocales.forEach((locale) => {
  registerLocaleData(locale);
});

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class LocaleConfigModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LocaleConfigModule,
      providers: [{
        provide: LOCALE_ID,
        useFactory: getLocaleId
      }]
    };
  }
}
